import packageJson from '../../package.json';

/**
 * Compares the version from the reducer with the version from package.json.
 * @param reducerVersion The version from the reducer to compare with the package.json version.
 * @param exactCompare If true, compares the full version string. If false, compares only the main version (ignoring pre-release tags).
 * @returns True if the versions differ, false otherwise.
 */
export const doVersionsDiffer: (
  reducerVersion: string | undefined,
  exactCompare?: boolean
) => boolean = (reducerVersion, exactCompare = true) => {
  if (!reducerVersion) {
    return false;
  }
  const packageJsonVersion = packageJson.version;
  if (exactCompare) {
    return reducerVersion !== packageJsonVersion;
  }
  const mainPackageJsonVersion = packageJsonVersion.split('-')[0];
  const mainReducerVersion = reducerVersion.split('-')[0];
  return mainPackageJsonVersion !== mainReducerVersion;
};
